import { Component, Mixins, Prop } from 'vue-property-decorator';
import { Props } from '../card';
import {
  NOTHING_TEXT,
  PLURAL_DEFAULT,
  WAITING_TEXT,
} from './const';

const pluralize = require('pluralize-ru');

@Component
export default class CalendarDetailProps extends Mixins(Props) {
  // Props
  @Prop({ type: Number, required: true })
  count: number;

  @Prop({ type: String, default: NOTHING_TEXT })
  nothingText: string;

  @Prop({ type: Array, default: () => PLURAL_DEFAULT })
  plural: Array<string>;

  @Prop({ type: String, default: WAITING_TEXT })
  text: string;

  @Prop({ type: Boolean, default: false })
  completed: boolean;

  // Computed
  get pluralized() {
    return pluralize(this.count, ...this.plural);
  }
}



// WEBPACK FOOTER //
// ./src/components/calendar/detail/props.ts